import * as types from './mutation-types'
import api from '../../../api/dispositions'
import { activeDispositions } from '../../getters';

export const getAllDispositions = async ({ commit, dispatch }) => {
  try {
    var result = await api.getAllDispositions();
    commit(types.DISPOSITIONS_GET_ALL, result.data);
  }
  catch (e) {
    let msg = "There was an error getting all dispositions.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
}

export const getActiveDispositions = async ({ commit, dispatch }) => {
  try {
    var result = await api.getActiveDispositions();
    commit(types.DISPOSITIONS_GET_ACTIVE, result.data);
  }
  catch (e) {
    let msg = "There was an error getting the dispostions. Please reload and try again.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
}

export const getAllDispositionTypes = async ({ commit, dispatch }) => {
  try {
    var result = await api.getAllDispositionTypes();
    commit(types.DISPOSITION_TYPES_GET_ALL, result.data);
  }
  catch (e) {
    let msg = "There was an error getting the disposition types. Please reload and try again.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
}

export const getActiveFollowupResultTypes = async ({ commit, dispatch }) => {
  try {
    var result = await api.getActiveFollowupResultTypes();
    commit(types.FOLLOWUPRESULTTYPES_GET_ACTIVE, result.data);
  }
  catch (e) {
    let msg = "There was an error getting the Followup result types. Please reload and try again.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
}

export const setSelectedResolution = ({ commit, dispatch }, r) => {
  commit(types.SET_SELECTED_RESOLUTION, r);
};

export const setSelectedTopic = ({ commit }, r) => {
  commit(types.SET_SELECTED_TOPIC, r);
};

export const saveResolution = async ({ commit, dispatch }, disposition) => {
  try {
    if (disposition.id === 0) {
      var result = await api.create(disposition)
      commit(types.ADD_NEW_RESOLUTION, result.data);
      return result;
    }
    else {
      var result = await api.update(disposition);
      commit(types.UPDATE_RESOLUTION, result.data);
      return result;
    }
  }
  catch (e) {
    let msg = "There was an error saving the disposition.";
    dispatch('showError', msg, { root: true });
    throw msg;
  }
}

export const saveTopic = ({ commit }, t) => {
  commit(types.SAVE_TOPIC, t);
}



// WEBPACK FOOTER //
// ./src/store/modules/dispositions/actions.js